import PropTypes from "prop-types";
import { sentenceCase } from "change-case";
import { Link as RouterLink } from "react-router-dom";
// material
import { Box, Grid, Card, Button, Typography, Stack } from "@mui/material";
import { PATH_DASHBOARD } from "../../../routes/paths";
import { fCurrency, fNumber } from "../../../utils/formatNumber";
import { ShowError } from "../../../utils/loader";
import { CheckPerm, DEBTOR_STATUS } from "../../../utils/apis";
import Label from "../../Label";
// ----------------------------------------------------------------------

SingleCard.propTypes = {
  debt: PropTypes.object,
};

function SingleCard({ debt }) {
  const { products, dib, owed, paid, status, balance } = debt;
  const numProducts = JSON.parse(products).length;
  const stat = DEBTOR_STATUS.filter((debt) => debt.value === status)[0];
  return (
    <Card
      variant="outlined"
      sx={{
        border: "0.4px solid",
        borderColor: "background.border",
        boxShadow:
          "4px 2px 124px rgba(46, 53, 58, 0.02), 0px 4px 124px rgba(46, 41, 78, 0.02)",
        borderRadius: "8px",
        display: "flex",
        alignItems: "center",
        p: 3,
      }}
    >
      <Box sx={{ flexGrow: 1, minWidth: 0, pl: 2, pr: 1 }}>
        <Typography variant="subtitle2" noWrap>
          {fNumber(numProducts)} {numProducts > 1 ? "products" : "product"}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
            Amount Owed: {fCurrency(owed)} <br /> Amount Paid: {fCurrency(paid)}
            <br /> Balance: {fCurrency(balance)}
          </Typography>
        </Box>
        <Button
          size="small"
          variant="outlined"
          color="primary"
          sx={{ mt: 2 }}
          component={RouterLink}
          to={`${PATH_DASHBOARD.subpages.debtor}/${dib}`}
        >
          View
        </Button>
      </Box>
      <Label variant="ghost" color={stat.color}>
        {sentenceCase(stat.label)}
      </Label>
    </Card>
  );
}

Debtors.propTypes = {
  debts: PropTypes.array.isRequired,
};

export default function Debtors({ debts }) {
  const hasPermission = CheckPerm("view_debtors");
  return (
    <Box sx={{ mt: 5 }}>
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography variant="h4" sx={{ mb: 3 }}>
          Debts History
        </Typography>
        {hasPermission && (
          <Button
            size="small"
            variant="outlined"
            color="primary"
            component={RouterLink}
            to={PATH_DASHBOARD.business.debtors}
          >
            View All
          </Button>
        )}
      </Stack>
      {debts.length > 0 ? (
        <Grid container spacing={3}>
          {debts.map((debt, index) => (
            <Grid key={index} item xs={12} md={4}>
              <SingleCard debt={debt} />
            </Grid>
          ))}
        </Grid>
      ) : (
        <ShowError
          message={
            new Error(
              "This customer does not have any debt attached at the moment!"
            )
          }
        />
      )}
    </Box>
  );
}
